  export const bosses = {

   HansVolter: {
    Normal1p: 1125,
    Normal2p: 1563,
    Normal3p: 2002,
    Normal4p: 2441,
    Normal5p: 2880,
    Normal6p: 3318,
    Hard1p: 1500,
    Hard2p: 2085,
    Hard3p: 2670,
    Hard4p: 3355,
    Hard5p: 3840,
    Hard6p: 4425,
    Suicidal1p: 1650,
    Suicidal2p: 2293,
    Suicidal3p: 2937,
    Suicidal4p: 3580,
    Suicidal5p: 4224,
    Suicidal6p: 4867,
    HOE1p: 1800,
    HOE2p: 2502,
    HOE3p: 3204,
    HOE4p: 3906,
    HOE5p: 4608,
    HOE6p: 5310,
    shield: {
      phase1: {
        Normal1p: 487,
        Normal2p: 852,
        Normal3p: 1217,
        Normal4p: 1582,
        Normal5p: 1948,
        Normal6p: 2313,
        Hard1p: 803,
        Hard2p: 1405,
        Hard3p: 2007,
        Hard4p: 2609,
        Hard5p: 3212,
        Hard6p: 3814,
        Suicidal1p: 969,
        Suicidal2p: 1695,
        Suicidal3p: 2422,
        Suicidal4p: 3149,
        Suicidal5p: 3876,
        Suicidal6p: 4602,
        HOE1p: 1965,
        HOE2p: 3438,
        HOE3p: 4912,
        HOE4p: 6386,
        HOE5p: 7860,
        HOE6p: 9333,
      },
      phase2: {
        Normal1p: 610,
        Normal2p: 1067,
        Normal3p: 1525,
        Normal4p: 1982,
        Normal5p: 2440,
        Normal6p: 2897,
        Hard1p: 1004,
        Hard2p: 1757,
        Hard3p: 2510,
        Hard4p: 3263,
        Hard5p: 4016,
        Hard6p: 4769,
        Suicidal1p: 1487,
        Suicidal2p: 2602,
        Suicidal3p: 3717,
        Suicidal4p: 4832,
        Suicidal5p: 5948,
        Suicidal6p: 7063,
        HOE1p: 2457,
        HOE2p: 4299,
        HOE3p: 6142,
        HOE4p: 7985,
        HOE5p: 9828,
        HOE6p: 11670,
      },
      phase3: {
        Normal1p: 731,
        Normal2p: 1279,
        Normal3p: 1827,
        Normal4p: 2375,
        Normal5p: 2924,
        Normal6p: 3472,
        Hard1p: 1205,
        Hard2p: 2108,
        Hard3p: 3012,
        Hard4p: 3916,
        Hard5p: 4820,
        Hard6p: 5723,
        Suicidal1p: 1785,
        Suicidal2p: 3123,
        Suicidal3p: 4462,
        Suicidal4p: 5801,
        Suicidal5p: 7140,
        Suicidal6p: 8478,
        HOE1p: 2948,
        HOE2p: 5159,
        HOE3p: 7370,
        HOE4p: 9581,
        HOE5p: 11792,
        HOE6p: 14003,
      },
    }

  },
  Patriarch: {
    Normal1p: 2812,
    Normal2p: 4218,
    Normal3p: 5624,
    Normal4p: 7030,
    Normal5p: 8436,
    Normal6p: 9842,
    Hard1p: 3750,
    Hard2p: 5625,
    Hard3p: 7500,
    Hard4p: 9375,
    Hard5p: 11250,
    Hard6p: 13125,
    Suicidal1p: 4237,
    Suicidal2p: 6355,
    Suicidal3p: 8474,
    Suicidal4p: 10592,
    Suicidal5p: 12711,
    Suicidal6p: 14829,
    HOE1p: 5212,
    HOE2p: 7818,
    HOE3p: 10424,
    HOE4p: 13030,
    HOE5p: 15636,
    HOE6p: 18242,
  },
  KingFleshpound: {
    Normal1p: 5512,
    Normal2p: 7661,
    Normal3p: 9811,
    Normal4p: 11961,
    Normal5p: 14110,
    Normal6p: 16260,
    Hard1p: 7262,
    Hard2p: 10094,
    Hard3p: 12926,
    Hard4p: 15758,
    Hard5p: 18590,
    Hard6p: 21422,
    Suicidal1p: 8750,
    Suicidal2p: 12162,
    Suicidal3p: 15575,
    Suicidal4p: 18987,
    Suicidal5p: 22400,
    Suicidal6p: 25812,
    HOE1p: 10500,
    HOE2p: 14595,
    HOE3p: 18690,
    HOE4p: 22785,
    HOE5p: 26880,
    HOE6p: 30975,
  },
  Abomination: {
    Normal1p: 5850,
    Normal2p: 8190,
    Normal3p: 10530,
    Normal4p: 12870,
    Normal5p: 15210,
    Normal6p: 17550,
    Hard1p: 7200,
    Hard2p: 10080,
    Hard3p: 12960,
    Hard4p: 15840,
    Hard5p: 18720,
    Hard6p: 21600,
    Suicidal1p: 8100,
    Suicidal2p: 11340,
    Suicidal3p: 14580,
    Suicidal4p: 17820,
    Suicidal5p: 21060,
    Suicidal6p: 24300,
    HOE1p: 9450,
    HOE2p: 13230,
    HOE3p: 17010,
    HOE4p: 20790,
    HOE5p: 24570,
    HOE6p: 28350,
  }
}


// WEBPACK FOOTER //
// ./src/pages/ZED/bosses.js